<template>
  <div class="index" v-if="data.style" :style="'position: relative;background: linear-gradient(180deg, #8BD1EF 0%, #054899 100%);background-color:'+data.style.backgroundColor">
    <div :style="'background-image:url('+require('@/assets/images/scan/customer_10000010/bg.png')+');background-size:100%;background-repeat:no-repeat'" class="p-t-10 p-b-50">
       <div class="templateTop  " >
      <div class="title fz-24 s_font_b text-ac m-b-5" style="color:#2182CA">产品信息</div>
      <div class="text-ac fz-14 m-b-22" style="color:#A1BBCD">百立乐长高高TM儿童成长配方奶粉(独立包装)</div>
    </div>
    <div class="templateForm  s_flex_bian_c p-l-14 p-r-14">
      <div class="formLeft">
        <div class="formItem s_flex_ali fz-16 m-b-10" style="color:#A1BBCD"><img src="@/assets/images/scan/customer_10000010/scpc.png" alt="" class="width-16 height-17 m-r-5">生产批次<div style="width:130px;height: 30px;background: #FFFFFF;box-shadow: 0px 4px 8px 0px rgba(112, 140, 161, 0.2);border-radius: 4px;" class="m-l-5"></div>
        </div>
        <div class="formItem s_flex_ali fz-16 m-b-10" style="color:#A1BBCD"><img src="@/assets/images/scan/customer_10000010/scrq.png" alt="" class="width-16 height-17 m-r-5">生产日期<div style="width:130px;height: 30px;background: #FFFFFF;box-shadow: 0px 4px 8px 0px rgba(112, 140, 161, 0.2);border-radius: 4px;" class="m-l-5"></div>
        </div>
        <div class="formItem s_flex_ali fz-16 " style="color:#A1BBCD"><img src="@/assets/images/scan/customer_10000010/bzq.png" alt="" class="width-16 height-17 m-r-5">保质期&nbsp;&nbsp;&nbsp;&nbsp;<div style="width:130px;height: 30px;background: #FFFFFF;box-shadow: 0px 4px 8px 0px rgba(112, 140, 161, 0.2);border-radius: 4px;" class="m-l-5"></div>
        </div>

      </div>
      <div class="formRight s_flex s_flex_fdc s_flex_center m-l-20 fz-14 " style="color:#C3AC16">
        <img src="@/assets/images/scan/customer_10000010/kf.png" alt="" class="width-28 height-4">
        <div>一键拨打</div>
        <div>贴心服务</div>
      </div>
    </div>
    </div>
    <div class="main">
      <div class="s_flex_around_c">
        <div class="left s_flex_fdc s_flex_center">
          <img src="@/assets/images/scan/customer_10000010/pzjk.png" alt="" class="width-120 height-96 m-b-20">
          <img src="@/assets/images/scan/customer_10000010/bfbz.png" alt="" class="width-120 height-70 m-b-18">
          <img src="@/assets/images/scan/customer_10000010/zwcx.png" alt="" class="width-120 height-82 m-b-23">
        </div>
        <div class="right  s_flex_fdc s_flex_center">
          <img src="@/assets/images/scan/customer_10000010/sggl.png" alt="" class="width-120 height-133 m-b-25">
          <img src="@/assets/images/scan/customer_10000010/bfly.png" alt="" class="width-120 height-82 m-b-34">
          <img src="@/assets/images/scan/customer_10000010/dbbg.png" alt="" class="width-130 height-43 m-b-7">
        </div>
      </div>
      <div class="bottom">
        <img src="@/assets/images/scan/customer_10000010/db.png" alt="" class="" style="width:100%">
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 337px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>